var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.help-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "help-svg",
    d: "M8,15.2c4,0,7.2-3.2,7.2-7.2c0-4-3.2-7.2-7.2-7.2C4,0.8,0.8,4,0.8,8C0.8,12,4,15.2,8,15.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "help-svg",
    d: "M8,11.2c1.8,0,3.2-1.5,3.2-3.2S9.8,4.8,8,4.8S4.8,6.2,4.8,8S6.2,11.2,8,11.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "help-svg",
    d: "M3,13l2.5-2.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "help-svg",
    d: "M13,13l-2.5-2.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "help-svg",
    d: "M5.5,5.5L3,3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "help-svg",
    d: "M10.5,5.5L13,3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b06aeea6406b5034babd6413177820ff.svg";
export { ForwardRef as ReactComponent };